import { Snackbar as MuiSnackbar, Alert, Typography } from "@mui/material";
import { SNACKBAR_SEVERITY } from "Common/Constants";

interface ISnackbar {
  open: boolean;
  handleClose: () => void;
  message?: string;
  severity?: SNACKBAR_SEVERITY;
}

export const Snackbar = (props: ISnackbar) => {
  const { open, severity, message, handleClose } = props;

  return (
    <MuiSnackbar
      open={open}
      autoHideDuration={5000}
      onClose={handleClose}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      sx={(theme) => ({
        "&.MuiSnackbar-root": {
          top: theme.spacing(7),
        },
        "& .MuiAlert-icon": {
          alignItems: "center",
        },
      })}
    >
      <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
        <Typography>{message}</Typography>
      </Alert>
    </MuiSnackbar>
  );
};
